export const normalizeAssetDetails = (rawSection = {}) => {
  const normalized = {
    properties: { ...(rawSection.properties || {}) },
    home_contents_value: rawSection.home_contents_value || "",
    savings: { ...(rawSection.savings || {}) },
    shares: { ...(rawSection.shares || {}) },
    supers: { ...(rawSection.supers || {}) },
    vehicles: { ...(rawSection.vehicles || {}) },
    assets: { ...(rawSection.assets || {}) },
  };

  return normalized;
};

export const buildPersistedAssetDetails = (normalizedSection) => {
  return {
    properties: { ...normalizedSection.properties },
    home_contents_value: normalizedSection.home_contents_value || "",
    savings: { ...normalizedSection.savings },
    shares: { ...normalizedSection.shares },
    supers: { ...normalizedSection.supers },
    vehicles: { ...normalizedSection.vehicles },
    assets: { ...normalizedSection.assets },
  };
};

export const createAssetId = (existingAssets, type) => {
  const keys = Object.keys(existingAssets);
  let nextNumber = keys.length + 1;
  while (keys.includes(String(nextNumber))) {
    nextNumber += 1;
  }
  return String(nextNumber);
};

export const buildEmptyProperty = () => {
  return {
    address: "",
    value: "",
    owing: "",
    rental_income: "",
    payout: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptySaving = () => {
  return {
    name: "",
    value: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptyShare = () => {
  return {
    name: "",
    value: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptySuper = () => {
  return {
    name: "",
    value: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptyVehicle = () => {
  return {
    make: "",
    model: "",
    year: "",
    value: "",
    owing: "",
    payout: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};

export const buildEmptyAsset = () => {
  return {
    name: "",
    value: "",
    held_by: "",
    applicant1: false,
    applicant2: false,
  };
};
